import React, {useEffect} from 'react';
import Aos from "aos";
import "aos/dist/aos.css";

import purple1 from './img/purple1.png';
import purple2 from './img/purple2.png';
import purple3 from './img/purple3.png';
import purple4 from './img/purple4.png';

import offer3 from './img/offer3.png';
import offer1 from './img/offer1.png';
// import offer2 from './img/offer2.png';

import ola from './img/ola.jpg';
import becky from './img/becky.jpg';
import nam101 from './img/nam101.png';
import bio from './img/bio.png';
import estate from './img/estate.jpg';

import instagram from './img/instagram.png';
import facebook from './img/facebook.png';
import linkedIn from './img/linkedin.png';
import youtube from './img/youtube.png';

const featureItems = [
  { image: purple1, title: 'Modern UI Design' },
  { image: purple2, title: 'Custom Excellence' },
  { image: purple3, title: 'High Performance' },
  { image: purple4, title: 'Seamless Integration' }
];

const valuePoints = [
  'Convert visitors into customers with a smooth user experience that works on any device',
  'We build with a growth mindset so launch your platform ensuring your site evolves as you do',
  'Replace manual processes with software designed for your unique business workflows'
];

const customDevelopment = [
  'A Modern UI Design',
  'Secure Client Portal',
  'Secure Multi-User Access',
  'Full Mobile Responsiveness',
  'Bespoke Content Management',
  'Fast Loading Speed Optimization',
  'Optimized Database Management',
  'System Document Generation',
  'Third-Party API Connections',
  'Robust Backend Architecture',
  'Ongoing Technical Support',
  'Future-Proof Upgradability'
];

const dataAutomation = [
  'Reliable Integration',
  'Secure Data Encryption',
  'Intuitive Control Panels',
  'Staff & User Management',
  'Custom Reporting Systems',
  'Dynamic Dashboard Visuals',
  'Real-Time Business Analytics',
  'Automated Email Notifications',
  'Optimized Database Management',
  'Complex Workflow Automation',
  'Future-Proof Upgradability',
  'Ongoing Technical Support'
];

const starterOfferPoints = [
  "Starter one-page websites, and landing pages from N$1,000",
  "Free web hosting for the first year that your website is live",
  "It's a good fit for small businesses, portfolios, and personal brands",
  "We also build larger websites, platforms, and automation solutions"
];

const projects = [
  { image: nam101, alt: 'nam101', title: 'Social Media Hub' },
  { image: ola, alt: 'medical', title: 'Healthcare Website' },
  { image: becky, alt: 'retail', title: 'Retail Website' },
  { image: estate, alt: 'realestate', title: 'Real Estate Platform' },
];

function Home() {
  useEffect(() => {
    Aos.init({});
  }, []);

  return (
    <main id="up" className="overflow-hidden">
      <section className="hero-section text-white">
        <div className="container py-5">
          <div className="row min-vh-100 align-items-center">
            <div className="col-lg-7">
              <span className="badge rounded-pill border border-white border-opacity-25 hero-badge mb-3">Web Development & Design</span>
              <h1 className="display-2 fw-bold text-uppercase mb-3">WebCitizen</h1>
              <p className="lead hero-copy mb-4">
                We build modern digital experiences that feel polished, perform fast, and support real growth.
              </p>
              <div className="d-flex flex-column flex-sm-row mb-4">
                <a href="mailto:web4citizen@gmail.com" className="btn btn-light btn-lg rounded-pill px-4 mb-3 mb-sm-0 me-sm-3">
                  Get a Quote
                </a>
                <a href="#services" className="btn btn-outline-light btn-lg rounded-pill px-4">
                  Explore Services
                </a>
              </div>
              <div className="row row-cols-1 row-cols-sm-2 g-3 hero-contact">
                <div className="col">
                  <div className="rounded-4 bg-white bg-opacity-10 border border-white border-opacity-10 p-3 h-100">
                    <span className="hero-contact-label">Phone</span>
                    <p className="mb-0">+264 85 764 1302</p>
                  </div>
                </div>
                <div className="col">
                  <div className="rounded-4 bg-white bg-opacity-10 border border-white border-opacity-10 p-3 h-100">
                    <span className="hero-contact-label">Email</span>
                    <p className="mb-0">web4citizen@gmail.com</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 mt-5 mt-lg-0">
              <div className="card border-0 shadow-lg rounded-4 hero-panel">
                <div className="card-body p-4 p-xl-5">
                  <div className="row row-cols-2 g-3">
                    {featureItems.map((item) => (
                      <div className="col" key={item.title}>
                        <div className="h-100 text-center p-3 rounded-4 bg-white bg-opacity-10 border border-white border-opacity-10">
                          <img src={item.image} alt={item.title} className="feature-icon mb-3" />
                          <p className="mb-0 fw-semibold">{item.title}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 section-surface">
        <div className="container py-lg-5">
          <div className="row g-4 text-center">
            {valuePoints.map((point) => (
              <div className="col-lg-4" key={point}>
                <div className="card h-100 border border-primary-subtle shadow rounded-4" data-aos="fade-up">
                  <div className="card-body p-5">
                    <p className="mb-0 fs-5 text-brand">{point}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-5 section-brand" id="services">
        <div className="container py-lg-5">
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-8">
              <p className="text-uppercase small fw-semibold text-white-50 mb-2">Our Services</p>
              <h2 className="display-5 fw-bold text-white">Custom builds for bold ideas</h2>
            </div>
          </div>

          <div className="row g-4 mb-2">
            <div className="col-lg-6">
              <div className="card h-100 border-0 shadow rounded-4 bg-white" data-aos="fade-up">
                <div className="card-body p-4 p-xl-5">
                  <div className="d-flex align-items-center mb-4">
                    <img alt="custom" src={offer1} className="service-icon me-3" />
                    <h3 className="h4 mb-0">Custom Development</h3>
                  </div>
                  <ul className="list-group list-group-flush">
                    {customDevelopment.map((item) => (
                      <li className="list-group-item px-0 bg-transparent text-brand service-list-item" key={item}>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card h-100 border-0 shadow rounded-4 bg-white" data-aos="fade-up" data-aos-delay="100">
                <div className="card-body p-4 p-xl-5">
                  <div className="d-flex align-items-center mb-4">
                    <img alt="data" src={offer3} className="service-icon me-3" />
                    <h3 className="h4 mb-0">Data & Automation</h3>
                  </div>
                  <ul className="list-group list-group-flush">
                    {dataAutomation.map((item) => (
                      <li className="list-group-item px-0 bg-transparent text-brand service-list-item" key={item}>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-center mt-4 mt-lg-5">
            <div className="col-xl-12">
              <div className="card border-0 shadow rounded-4 service-note overflow-hidden">
                <div className="card-body p-4 p-lg-5">
                  <div className="row g-4 align-items-center">
                    <div className="col-lg-7">
                      <span className="badge bg-white border border-2 border-primary-subtle rounded-pill text-uppercase fw-bold px-3 py-2 mb-3 service-note-tag">Flexible options for different budgets</span>
                      {/* <h3 className="display-6 fw-bold text-brand mb-3">Web solutions that can start from just N$1,000</h3> */}
                      <p className="service-note-copy mb-4 mt-2">
                        Whether you just need a simple online presence or a more advanced solution, we tailor the work to your needs.
                      </p>
                      <div className="row g-3">
                        {starterOfferPoints.map((item) => (
                          <div className="col-sm-6" key={item}>
                            <div className="h-100 p-3 rounded-4 border bg-white bg-opacity-75 shadow-sm starter-point">
                              <p className="mb-0">{item}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="col-lg-5">
                      <div className="starter-highlight h-100">
                        <p className="text-uppercase small fw-semibold mb-2">Affordable starting point</p>
                        <div className="starter-price mb-3">From N$1,000</div>
                        <p className="mb-3">
                          Entry-level website packages are available, while larger custom builds are quoted based on your needs.
                        </p>
                        <p className="starter-bonus mb-4">Free hosting for the first year your website is live.</p>
                        <div className="d-grid gap-2">
                          <a href="tel:+264857641302" className="btn btn-outline-light rounded-pill px-4">
                            +264 85 764 1302
                          </a>
                          <a href="mailto:web4citizen@gmail.com" className="btn btn-outline-light rounded-pill px-4">
                            web4citizen@gmail.com
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 section-surface" id="projects">
        <div className="container py-lg-5">
          <div className="row g-5 align-items-start">
            <div className="col-lg-7">
              <h2 className="display-6 fw-bold text-brand mb-3">Our Projects</h2>
              <p className="fs-5 mb-4">We translate complex requirements into clean, modern, effective solutions.</p>
              <a
                href="https://imanuel.vercel.app/"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-brand rounded-pill px-4 mb-4"
              >
                View Portfolio
              </a>
              <div
                id="projectsCarousel"
                className="carousel slide shadow-lg"
                data-bs-ride="carousel"
              >
                <div className="carousel-indicators">
                  {projects.map((project, index) => (
                    <button
                      key={project.title}
                      type="button"
                      data-bs-target="#projectsCarousel"
                      data-bs-slide-to={index}
                      className={index === 0 ? 'active' : ''}
                      aria-current={index === 0 ? 'true' : undefined}
                      aria-label={`Slide ${index + 1}`}
                    ></button>
                  ))}
                </div>
                <div className="carousel-inner rounded-4">
                  {projects.map((project, index) => (
                    <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={project.title}>
                      <img src={project.image} className="d-block w-100 project-image border border-primary-subtle" alt={project.alt} />
                      <div className="carousel-caption">
                        <span className="badge bg-light text-primary-emphasis rounded-pill border border-white project-badge">{project.title}</span>
                      </div>
                    </div>
                  ))}
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#projectsCarousel" data-bs-slide="prev">
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#projectsCarousel" data-bs-slide="next">
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
            <div className="col-lg-5" id="about">
                <div className="card border-0 shadow rounded-4 bg-white h-100">
                  <div className="card-body p-4 p-xl-5 text-center text-lg-start">
                    <img alt="bio" src={bio} className="bio-image rounded-circle shadow mb-4" />
                    <p className="text-uppercase small fw-semibold text-brand mb-2">About</p>
                    <p className="fs-5 mb-3 text-brand">
                      We build clean, modern websites that are user friendly across all devices.
                      Whether you have a fully formed plan or just an idea, we’re here to help you build it.
                    </p>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </section>

      <footer className="py-5 footer-section">
        <div className="container">
          <div className="row g-4 align-items-center">
              <div className="col-md-6 text-center text-md-start">
                <p className="text-uppercase small fw-semibold mb-2 text-white-50">Connect</p>
                <div className="d-flex justify-content-center justify-content-md-start gap-3">
                <a href="https://www.facebook.com/people/Webcitizen/100054567904106/" target="_blank" rel="noopener noreferrer" className="social-link d-inline-flex align-items-center justify-content-center rounded-circle">
                  <img src={facebook} alt="facebook icon" />
                </a>
                <a
                  href="https://www.youtube.com/channel/UCAqwXZJOxBOBC6ijtOu75VQ/featured?view_as=subscriber"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link d-inline-flex align-items-center justify-content-center rounded-circle"
                >
                  <img src={youtube} alt="youtube icon" />
                </a>
                <a href="https://www.instagram.com/webcitizen_insta/" target="_blank" rel="noopener noreferrer" className="social-link d-inline-flex align-items-center justify-content-center rounded-circle">
                  <img src={instagram} alt="instagram icon" />
                </a>
                <a
                  href="https://www.linkedin.com/in/emmanuel-o-a8330414a/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link d-inline-flex align-items-center justify-content-center rounded-circle"
                  >
                    <img src={linkedIn} alt="linkedin icon" />
                  </a>
                </div>
                <p className="footer-location mb-0 mt-3 fs-6">Windhoek, Namibia • Remote</p>
              </div>
            <div className="col-md-6 text-center text-md-end">
              <a href="#up" className="btn btn-outline-light rounded-pill px-4">
                Back to Top
              </a>
            </div>
          </div>
        </div>
      </footer>
    </main>
  );
}

export default Home;
